import type { SVGProps } from "react";

export function Header0Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 15V7.5C5 6.57174 5.36875 5.6815 6.02513 5.02513C6.6815 4.36875 7.57174 4 8.5 4C9.42826 4 10.3185 4.36875 10.9749 5.02513C11.6313 5.6815 12 6.57174 12 7.5V15M5 10H12M10 18L13 21L20 14"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Header1Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 18V10L17 12M4 6V18M12 6V18M11 18H13M3 18H5M4 12H12M3 6H5M11 6H13"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Header2Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 12C17 11.4696 17.2107 10.9609 17.5858 10.5858C17.9609 10.2107 18.4696 10 19 10C19.5304 10 20.0391 10.2107 20.4142 10.5858C20.7893 10.9609 21 11.4696 21 12C21 12.591 20.583 13.318 20.184 13.858L17 18.001H21M4 6V18M12 6V18M11 18H13M3 18H5M4 12H12M3 6H5M11 6H13"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Header3Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 12C17 11.6044 17.1173 11.2178 17.3371 10.8889C17.5568 10.56 17.8692 10.3036 18.2346 10.1522C18.6001 10.0009 19.0022 9.96126 19.3902 10.0384C19.7781 10.1156 20.1345 10.3061 20.4142 10.5858C20.6939 10.8655 20.8844 11.2219 20.9616 11.6098C21.0387 11.9978 20.9991 12.3999 20.8478 12.7654C20.6964 13.1308 20.44 13.4432 20.1111 13.6629C19.7822 13.8827 19.3956 14 19 14C19.3956 14 19.7822 14.1173 20.1111 14.3371C20.44 14.5568 20.6964 14.8692 20.8478 15.2346C20.9991 15.6001 21.0387 16.0022 20.9616 16.3902C20.8844 16.7781 20.6939 17.1345 20.4142 17.4142C20.1345 17.6939 19.7781 17.8844 19.3902 17.9616C19.0022 18.0387 18.6001 17.9991 18.2346 17.8478C17.8692 17.6964 17.5568 17.44 17.3371 17.1111C17.1173 16.7822 17 16.3956 17 16M4 6V18M12 6V18M11 18H13M3 18H5M4 12H12M3 6H5M11 6H13"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Header4Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 18V10L16 16H21M4 6V18M12 6V18M11 18H13M3 18H5M4 12H12M3 6H5M11 6H13"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Header5Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 18H19C19.5304 18 20.0391 17.7893 20.4142 17.4142C20.7893 17.0391 21 16.5304 21 16C21 15.4696 20.7893 14.9609 20.4142 14.5858C20.0391 14.2107 19.5304 14 19 14H17V10H21M4 6V18M12 6V18M11 18H13M3 18H5M4 12H12M3 6H5M11 6H13"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
